export const CATEGORY = 'Multilingual';
